// extracted by mini-css-extract-plugin
module.exports = {"errorText":"Landing_errorText__3YkZI"};